







import Vue from "vue";
export default Vue.extend({
  mounted(){
    // Ask for notification permission
    Notification.requestPermission().then(permission => null)
    
  }
});
